var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3660_5184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04102 5.4372V6.5622H6.60352V8.9997H5.47852V6.5622H3.04102V5.4372H5.47852V2.9997H6.60352V5.4372H9.04102Z",
    fill: "#197A56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04102 0C9.35472 0 12.041 2.68624 12.041 5.9999C12.041 9.31355 9.35472 11.9998 6.04102 11.9998C2.72731 11.9998 0.0410156 9.31355 0.0410156 5.9999C0.0410156 2.68624 2.72731 0 6.04102 0ZM6.04102 1.125C8.73342 1.125 10.916 3.30758 10.916 5.9999C10.916 8.69221 8.73342 10.8748 6.04102 10.8748C3.34861 10.8748 1.16602 8.69221 1.16602 5.9999C1.16602 3.30758 3.34861 1.125 6.04102 1.125Z",
    fill: "#197A56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3660_5184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.0410156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMore);
export default __webpack_public_path__ + "static/media/show-more.6108a5d2c237aa8a2ba9819d4a9b722d.svg";
export { ForwardRef as ReactComponent };